<template>
	<main id="candidateSelection">
		<form>
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<h1>{{getLabel(labels.title)}}</h1>
			<input type="text" v-on:input="updateName" v-bind:placeholder="getLabel(labels.input)" id="name_input">
			<div v-if="!selected_candidate">
				<div v-if="loading">{{getLabel(labels.loading)}}...</div>
				<div v-else>
					<ul id="candidateList">
					<li v-for="(value, key) in candidates">
						<span class="selectable" v-on:click.self.stop.prevent="selectCandidate(value)">{{value.name}} : ({{printArray(value.phones || value.mails) || getLabel(labels.noContact)}})</span>
					</li>
					</ul>
				</div>
			</div>
			<div v-else>
				<div class="cat_name">{{selected_candidate.name}}</div>
				<div v-if="selected_candidate.files && selected_candidate.files.length">
					<p class="cat_name">{{getLabel(labels.resumes)}} :</p>
					<ul>
						<li v-for="(file, key) in selected_candidate.files"><a href="#" v-on:click.self.stop.prevent="downloadCV(file._id, fileName(selected_candidate, key, file), key)" v-bind:id="'cvlink_'+key">{{downloading_file === key ? getLabel(labels.loading) : fileName(selected_candidate, key, file)}}</a></li>
					</ul>
				</div>
				<div v-if="selected_candidate.mails && selected_candidate.mails.length">
					<p class="cat_name">{{getLabel(labels.mails)}} :</p>
					<p>{{selected_candidate.mails.join(', ')}}</p>
				</div>
				<div v-if="selected_candidate.phones && selected_candidate.phones.length">
					<p class="cat_name">{{getLabel(labels.phones)}} :</p>
					<p>{{selected_candidate.phones.join(', ')}}</p>
				</div>
				<div v-if="selected_candidate.metas">
					<p class="cat_name">Tags :</p>
					<table v-for="(meta, key) in metaList()">
						<tr v-bind:class="key < metaList().length - 1 ? 'border_bottom' : ''"><td class="left cell_25 border_right">{{meta.name}}</td><td>{{meta.values.join(', ')}}</td></tr>
					</table>
				</div>
				<div v-if="selected_candidate.comments">
					<p class="cat_name">{{getLabel(labels.comments)}} :</p>
					<table>
						<tr class="border_bottom"><td class="border_right">Date</td><td class="border_right">{{getLabel(labels.author)}}</td><td>{{getLabel(labels.comment)}}</td></tr>
						<tr v-for="(comment, key) in selected_candidate.comments" v-bind:class="key < selected_candidate.comments.length - 1 ? 'border_bottom' : ''">
							<td class="border_right">{{printDate(comment.date)}}</td><td class="border_right">{{comment.user}}</td><td class="left comment">{{comment.text}}</td>
						</tr>
					</table>
				</div>
			</div>
			<button v-on:click.self.stop.prevent="validateForm()" v-bind:class="isActive() ? 'selected' : ''">{{getLabel(labels.button)}}</button>
		</form>
	</main>
</template>

<script>
import libs from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

export default {
	name: 'candidateSelectionTpl',
	data() {
		return {
			candidates : [],
			search_input: '',
			loading : false,
			queryTimeout : null,
			selected_candidate : null,
			downloading_file : false,
			labels : {
				title : {
					fr : 'Sélection du candidat',
					en : 'Application selection'
				},
				input : {
					fr : 'Nom du candidat',
					en : "Applicant name"
				},
				button : {
					fr : 'Suivant',
					en : 'Next'
				},
				noContact : {
					fr : "Pas d'informations de contact",
					en : "No contacts"
				},
				phones : {
					fr : 'Téléphone(s)',
					en : 'Phone(s)'
				},
				mails : {
					fr : 'E-mail(s)',
					en : 'Mail(s)'
				},
				author : {
					fr : 'Auteur',
					en : 'Author'
				},
				comment : {
					fr : 'Commentaire',
					en : 'Comment'
				},
				comments : {
					fr : 'Commentaires',
					en : 'Comments'
				},
				resumes : {
					fr : 'CV(s)',
					en : 'Résumé(s)'
				},
				loading : {
					fr : 'Chargement',
					en : 'Loading'
				}
			}
		};
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex', 'api'],
	computed : {
		prettyDate : function(){
			return libs.prettyDate(this.lang, 'text');
		}
	},
	methods : {
		getLabel : componentTools.getLabel,
		isActive : function() {
			return !!this.selected_candidate;
		},
		validateForm : function(){
			const tplName = this.$options.name + '_' + this.templateIndex;
			localStorage.removeItem(tplName);
			this.$emit('validateStep', this.$options.name,
			{
				name : this.selected_candidate.name,
				mail : this.selected_candidate.mails && this.selected_candidate.mails[0],
				mails : this.selected_candidate.mails,
				phones : this.selected_candidate.phones,
				profile : this.selected_candidate._id
			});
		},
		printArray : function(array) {
			if(!array || !array.length) return '';
			return array.join(', ');
		},
		selectCandidate : function(data) {
			if(!data) return;

			this.search_input = '';
			this.selected_candidate = data;
			//Save candidate in localStorage to avoid loosing selection
			const tplName = this.$options.name + '_' + this.templateIndex;
			try{
				const candidate = JSON.stringify(data);
				localStorage.setItem(tplName, candidate);
			}catch(e){console.log(e);}
		},
		metaList : function() {
			const metas = (this.selected_candidate && this.selected_candidate.metas) || {};
			return Object.keys(metas).map(e => metas[e]);
		},
		printDate : function(date) {
			return libs.prettyDate(this.lang, 'short', date);
		},
		fileName : function(candidate, key, file) {
			let fname = candidate.name + '_'+ (key + 1);
			fname = fname.replace(/\W/g,'_');
			fname += '.' + file.ext;
			return fname;
		},
		downloadCV : function(hash, fname, index) {
			this.downloading_file = index;
			this.api.downloadCv(this.currentSession.event, hash).then(res => {
				window.saveAs(res, fname); //Use external lib to handle all browser
			}).catch(e => console.log(e)).finally(() => this.downloading_file = false);
		},
		updateName : function(event) { //Do not use v-model to force update in mobile web browser
			const val = event.target && event.target.value || '';
			this.search_input = val;
		}
	},
	watch : {
		search_input : function(data) {
			const self = this;
			if(!data || data.length <= 2) return;
			self.selected_candidate = null;
			self.candidates = [];
			self.loading = true;
			if(self.queryTimeout) clearTimeout(self.queryTimeout);
			self.queryTimeout = setTimeout(function(){
				self.api.searchCandidate(self.currentSession.event, data).then(answer => {
					if(Array.isArray(answer)) self.candidates = answer;
				}).catch(error => console.log(error))
				.finally(() => self.loading = false);
			}, 800);
		}
	},
	created : componentTools.created,
	mounted : function(){
		componentTools.mounted.call(this);
		//Restore auto saved text inputs
		const tplName = this.$options.name + '_' + this.templateIndex;
		let last_candidate = localStorage.getItem(tplName);
		if(last_candidate) {
			try{
				const candidate = JSON.parse(last_candidate);
				this.search_input = '';
				this.selected_candidate = candidate;
			}catch(e){console.log(e);}
		}
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#candidateSelection p{
	text-align: justify;
}
#candidateSelection input{
	display: inline-block;
	width: 50%;

}
#candidateSelection button{
	display: block;
}
#candidateSelection .selectable{
	cursor : pointer;
}
#candidateSelection #name_input {
	margin-bottom : 10px;
}
@media screen
and (max-width: 480px){
	#candidateSelection button{
		width: 40%;
	}
}
#candidateSelection .left {
	text-align : left;
}

#candidateSelection table {
	width : 100%;
	border-collapse : collapse;
}

#candidateSelection .border_bottom {
	border-bottom : dashed 1px black;
}

#candidateSelection table td {
	padding : 5px;
}

#candidateSelection .border_right {
	border-right : dashed 1px black;
}

#candidateSelection .cat_name {
	font-weight : bold;
}

#candidateSelection .cell_25 {
	width : 25%;
}
#candidateSelection .comment {
	white-space : pre-wrap;
}
#candidateSelection a{
	text-decoration : underline;
}
@media screen
and(max-height: 625px)
and(min-height: 461px)
and(max-width: 480px){
	#candidateSelection form button {
			margin-bottom: 20px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/candidateSelection.vue